const pushGoogleAnalyticsEvent = (eventName, options) => {
  if (window.gtag) {
    window.gtag('event', eventName, options);
  }
};

export { pushGoogleAnalyticsEvent as pushEvent };
